import { ICommitmentResponse, IProduct } from "../../fetchOrderProducts";

export function isCommitmentResponse(
  product: IProduct,
): product is ICommitmentResponse {
  return (
    "specificationId" in product && product.specificationId === "COMMITMENT"
  );
}
